import { render, staticRenderFns } from "./AfterSalesRefundPage.vue?vue&type=template&id=c313a882&scoped=true"
import script from "./AfterSalesRefundPage.vue?vue&type=script&lang=js"
export * from "./AfterSalesRefundPage.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesRefundPage.vue?vue&type=style&index=0&id=c313a882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313a882",
  null
  
)

export default component.exports